import { apiCall } from "../helpers/api";

export const interests = (params = {}) => dispatch => {
    params.path = params.path || "interests";
    return dispatch(apiCall(params));
}